import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Checkbox from '@cimpress/react-components/lib/Checkbox';
import every from 'lodash/every';
import has from 'lodash/has';
import { selectTerm, removeTerm, selectMultipleTerms, removeMultipleTerms } from '../../../reducers/termselect/actions';

class MultiSelectCell extends PureComponent {
  static propTypes = {
    selectAll: PropTypes.bool,
    original: PropTypes.objectOf(PropTypes.any),
    data: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
    selectedTerms: PropTypes.objectOf(PropTypes.any).isRequired,
    onSelectTerm: PropTypes.func.isRequired,
    onRemoveTerm: PropTypes.func.isRequired,
    onSelectAllTerms: PropTypes.func.isRequired,
    onRemoveAllTerms: PropTypes.func.isRequired
  };

  isSelected = () => {
    const { original, selectedTerms } = this.props;
    const { termId, revisionId } = original;
    return has(selectedTerms, `${termId}${revisionId}`);
  };

  isMultiSelected = () => {
    const { selectedTerms, data } = this.props;
    const selected = every(data, term => {
      if (!term || !term._original) return false;
      const { _original } = term;
      const { termId, revisionId } = _original;
      const termKey = `${termId}${revisionId}`;
      return has(selectedTerms, termKey);
    });
    return selected;
  };

  onSelect = (e, term) => {
    const { onSelectTerm, onRemoveTerm, selectedTerms } = this.props;
    const { termId, revisionId } = term;
    if (has(selectedTerms, `${termId}${revisionId}`)) {
      return onRemoveTerm(term);
    }
    return onSelectTerm(term);
  };

  onSelectAll = () => {
    const { data, onSelectAllTerms, onRemoveAllTerms } = this.props;
    const termList = data.map(term => term._original);
    const selected = this.isMultiSelected();
    if (selected) {
      return onRemoveAllTerms(termList);
    }
    return onSelectAllTerms(termList);
  };

  render() {
    const { selectAll, original } = this.props;

    const selected = selectAll ? this.isMultiSelected() : this.isSelected();

    return selectAll ? (
      <Checkbox checked={selected} onChange={this.onSelectAll} />
    ) : (
      <Checkbox checked={selected} onChange={this.onSelect} payload={original} />
    );
  }
}

const mapStateToProps = state => ({
  selectedTerms: state.termSelectReducer.selectedTerms
});

const mapDispatchToProps = dispatch => ({
  onSelectTerm: term => dispatch(selectTerm(term)),
  onRemoveTerm: term => dispatch(removeTerm(term)),
  onSelectAllTerms: terms => dispatch(selectMultipleTerms(terms)),
  onRemoveAllTerms: terms => dispatch(removeMultipleTerms(terms))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MultiSelectCell);
